module.exports = __webpack_public_path__ + "static/media/chat-fill.33350cf9.svg";